import styled from "styled-components";
import FormTextArea from "Components/FormTextArea";
import { mobileSize } from "Themes/Metrics";

export const CommentContainer = styled(FormTextArea)`
  border-radius: 5px;
  width: 100%;
  padding: 20px;
  border: solid 2px black;
`;

export const CommentButtonContainer = styled.div`
  width: 20%;
  @media ${mobileSize.large} {
    width: 40%;
  }
`;
